// names gotten from: http://chir.ag/projects/name-that-color
const COLORS = {
  GREEN: "#6FDEA9",      // bermuda
  RIVERBED: "#414E5A",   // background
  SEAGREEN: "#6A9997",   // close to patina
  INDIGO: "#414A67",     // fiord
  GRAY: "#858C98",       //regent gray
  PEWTER: "#9BADA1",
  SEABLUE: "#7296B3",    // ship cove
  GRAPEFRUIT: "#D69A9A", // can can
  TEAL: "008080",
};

export default COLORS;